<div
  class="mx-auto max-w-md px-5 pt-2 lg:max-w-full lg:px-0 lg:pt-0"
  [style.color]="textColor | contentBuilderColor"
>
  @if (basket$ | async; as basket) {
    @if (basket.id) {
      <div class="mb-4 flex items-center px-3 py-3">
        <span class="icon icon-group-order text-2xl"></span>
        @if (basket.user.firstname) {
          <span class="pl-4 font-accent font-bold">
            {{ 'basket.group-command-of' | translate }}
            {{ basket.user.firstname }}</span
          >
        }
        @if (!basket.user.firstname) {
          <span class="pl-4 font-accent font-bold"> {{ 'basket.group-command' | translate }}</span>
        }
      </div>
    }
  }
  @if (isGroupedOrderAllowed) {
    <div class="pb-6">
      <app-button-atom
        [size]="'XS'"
        thickSize="S"
        [label]="
          ((basketId$ | async)
            ? 'shop-page.share-my-grouped-order'
            : 'shop-page.create-my-grouped-order'
          ) | translate
        "
        type="light"
        class="dot dot-2"
        [icon]="'icon-group-order'"
        (click)="openGroupOrderModal()"
      ></app-button-atom>
    </div>
  }
  <div class="flex items-center justify-between">
    <h1
      class="font-accent text-2xl font-bold lg:text-3xl"
      [style.color]="headingColor | contentBuilderColor"
    >
      {{ 'basket.my-cart' | translate }}
    </h1>
    <app-button-atom
      [label]="'basket.clear-basket' | translate"
      size="XS"
      type="outlined"
      thickSize="XS"
      color="neutral"
      [icon]="'icon-garbage'"
      (click)="clearCart()"
    ></app-button-atom>
  </div>
  @let cartVm = cartListVm$ | async;
  @if (!cartVm?.isOrderValidationInProgress) {
    @if ((basketId$ | async) && (reconstructedShareOrderBasket$ | async); as reconstructedBasket) {
      @if (reconstructedBasket.length) {
        @for (elem of reconstructedBasket; track elem) {
          <div>
            <p
              class="mt-4 px-1 py-2 text-center font-base text-sm font-bold text-white"
              [style.color]="headingColor | contentBuilderColor"
            >
              @if (elem.user.firstname) {
                <span>{{ elem.user.firstname }}</span>
              }
              @if (!elem.user.firstname) {
                <span>{{ 'basket.anonymous' | translate }}</span>
              }
              @if ((userId$ | async) === elem.user.id) {
                <span> ({{ 'basket.you' | translate }})</span>
              }
            </p>
            <ul>
              @for (item of elem.items; track item; let index = $index; let last = $last) {
                <li
                  class="border-neutral-300 {{ $any(item.product)?.id }}"
                  [ngClass]="{ 'border-t': index > 0, 'border-b': last }"
                >
                  @if (basket$ | async; as basket) {
                    <div class="align-center flex justify-center gap-3.5">
                      <app-overview-cart-item-atom
                        class="flex-auto"
                        [id]="item.itemId"
                        [isProductExists]="!!$any(item.product)?.[productKeys.Id]"
                        [name]="$any(item.product)?.[productKeys.Name] ?? 'INVALID'"
                        [groupAdditionsItems]="$any(item.product)?.additions?.items ?? []"
                        [groupCompoundItems]="$any(item.product)?.categories ?? []"
                        [quantity]="item.quantity"
                        [price]="item.price"
                        [formatPrice]="true"
                        [isOwner]="(userId$ | async) === elem.user.id"
                        [displayRemoveIcon]="
                          (userId$ | async) === elem.user.id || basket.user.id === (userId$ | async)
                        "
                        [isBasketOrder]="true"
                        [quantityBadgeTextColor]="quantityBadgeTextColor"
                        [quantityBadgeBackgroundColor]="quantityBadgeBackgroundColor"
                        (updateItem)="onUpdateItem(item.itemId, $any(item.product), item.id)"
                        (removeItem)="onRemoveBasketItem(item.id)"
                      ></app-overview-cart-item-atom>
                    </div>
                  }
                </li>
              }
            </ul>
            @for (coupon of elem.subCart?.coupons; track coupon) {
              <div
                class="flex justify-between border-b border-neutral-300 py-3"
                [class.opacity-50]="coupon.removeInProgress"
              >
                <div class="text-sm font-normal leading-snug lg:text-base">
                  <div>
                    @if (coupon.name) {
                      {{ coupon.name }}
                    }
                    @if (!coupon.name) {
                      {{ 'basket.discount-voucher' | translate }}
                      «{{ coupon.code }}»
                    }
                  </div>
                  @if (coupon.type === 'ERROR') {
                    <div class="text-xs text-error-800">
                      @if (coupon.error) {
                        {{ coupon.error }}
                      }
                      @if (!coupon.error) {
                        {{ 'basket.invalid-voucher' | translate }}
                      }
                    </div>
                  }
                  @if ((userId$ | async) === elem.user.id) {
                    <div>
                      <a
                        (click)="onRemoveCoupon(coupon)"
                        class="cursor-pointer text-primary-600"
                        >{{ 'basket.delete' | translate }}</a
                      >
                    </div>
                  }
                </div>
                <div class="flex flex-row items-center justify-end">
                  @if (coupon.type !== 'ERROR') {
                    <div class="icon icon-coupon-3 pl-4 text-neutral-400"></div>
                  }
                  @if (coupon.type === 'ERROR') {
                    <div class="icon icon-warning-circle pl-4 text-error-800"></div>
                  }
                  @if (coupon.type !== 'ERROR') {
                    <div class="w-20 text-right text-sm leading-5">
                      –
                      <app-price-atom
                        [bold]="false"
                        [amount]="coupon.amount_off ?? 0"
                        [format]="true"
                        size="SM"
                      ></app-price-atom>
                    </div>
                  }
                </div>
              </div>
            }
            @if (elem.subCart?.total || elem.subCart?.total === 0) {
              <div class="flex justify-between py-3 text-base">
                <span class="font-accent font-bold">{{ 'basket.subtotal' | translate }} :</span>
                <app-price-atom
                  [amount]="elem.subCart?.total ?? 0"
                  [bold]="true"
                  [format]="true"
                ></app-price-atom>
              </div>
            }
            @if (basket$ | async; as basket) {
              <div class="pb-3">
                @if (basket.user.id === (userId$ | async) && basket.user.id !== elem.user.id) {
                  <a
                    class="flex cursor-pointer items-center text-secondary-600"
                    (click)="removeUserFromCart(elem.user.id)"
                  >
                    <span class="icon icon-cross mr-2"></span>
                    <span>{{ 'group-order-modal.delete-guest-button' | translate }}</span>
                  </a>
                }
              </div>
            }
          </div>
        }
      } @else {
        <div class="mx-auto my-5 max-w-screen-sm px-5 py-5">
          <p class="rounded-sm bg-highlight-50 p-4 text-center font-accent">
            {{ 'basket.empty-basket' | translate }}
          </p>
        </div>
      }
    }
    @if (!(reconstructedShareOrderBasket$ | async)?.length) {
      @if (cartVm?.reconstructedCart; as cartByShop) {
        @if (cartByShop.length) {
          @for (cart of cartByShop; track cart[reconstructedCartKeys.Shop][shopKeys.Id]) {
            <div>
              <h2
                class="mt-8xs text-base font-base font-bold text-neutral-600"
                [style.color]="secondaryTextColor | contentBuilderColor"
              >
                @if (cart[reconstructedCartKeys.Shop][shopKeys.Slug]) {
                  <a
                    [link]="'/shops/' + cart[reconstructedCartKeys.Shop][shopKeys.Slug]"
                    class="cursor-pointer hover:underline"
                  >
                    {{ cart[reconstructedCartKeys.Shop][shopKeys.Name] }}
                  </a>
                } @else {
                  <span>{{ cart[reconstructedCartKeys.Shop][shopKeys.Name] }}</span>
                }
              </h2>
              <ul>
                @for (
                  item of cart[reconstructedCartKeys.Items];
                  track item[reconstructedCartItemKeys.Item][cartItemKeys.Id];
                  let index = $index;
                  let last = $last
                ) {
                  <li
                    class="border-neutral-300 {{
                      item[reconstructedCartItemKeys.Item][cartItemKeys.Id]
                    }}"
                    [ngClass]="{ 'border-t': index > 0, 'border-b': last }"
                  >
                    <app-overview-cart-item-atom
                      [id]="item[reconstructedCartItemKeys.Item][cartItemKeys.Id]"
                      [isProductExists]="
                        !!item[reconstructedCartItemKeys.Product]?.[productKeys.Id]
                      "
                      [name]="
                        item[reconstructedCartItemKeys.Product]?.[productKeys.Name] ?? 'INVALID'
                      "
                      [childItems]="item[reconstructedCartItemKeys.ChildCompoundItems] ?? []"
                      [quantity]="item[reconstructedCartItemKeys.Item][cartItemKeys.Quantity]"
                      [price]="item[reconstructedCartItemKeys.UnitPrice] ?? 0"
                      [textColor]="textColor"
                      [productNameColor]="productNameColor"
                      [productDetailsColor]="productDetailsColor"
                      [quantityBadgeTextColor]="quantityBadgeTextColor"
                      [quantityBadgeBackgroundColor]="quantityBadgeBackgroundColor"
                      (updateItem)="onUpdateItem($event)"
                      (removeItem)="onRemoveCartItem($any($event), cart, cartByShop)"
                    ></app-overview-cart-item-atom>
                  </li>
                }
              </ul>
            </div>
          }
        } @else {
          <div class="mx-auto my-5 max-w-screen-sm px-5 py-5">
            <p class="rounded-sm bg-highlight-50 p-4 text-center font-accent">
              {{ 'basket.empty-basket' | translate }}
            </p>
          </div>
        }
      } @else {
        <div class="pt-8">
          @for (i of [].constructor(2); track $index) {
            <div class="flex max-w-screen-sm flex-col justify-between pb-3">
              <div class="flex w-full flex-row justify-between">
                <div class="mb-3 h-4 w-32 animate-pulse rounded bg-neutral-100"></div>
              </div>
              @for (j of [].constructor(3); track $index) {
                <div class="flex max-w-screen-sm justify-between pb-2">
                  <div class="flex w-full flex-row justify-between">
                    <div class="mb-2 h-4 w-7/12 animate-pulse rounded bg-neutral-50"></div>
                    <div class="mb-2 h-4 w-14 animate-pulse rounded bg-neutral-50"></div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    }
  } @else {
    @for (i of [].constructor(5); track $index) {
      <div class="flex w-full items-center justify-between border-b border-neutral-300 py-3">
        <div class="flex w-9/12">
          <p class="ml-2 h-4 w-7/12 animate-pulse bg-neutral-200"></p>
        </div>
        <div class="h-4 w-10 animate-pulse bg-neutral-200"></div>
      </div>
    }
  }
</div>
